"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAuthServiceConfig = void 0;
const env_1 = require("../env/env");
exports.userAuthServiceConfig = {
    USER_AUTH_SERVICE_URL: env_1.env.getString('USER_AUTH_SERVICE_URL') || 'http://localhost:3434',
};
//# sourceMappingURL=userAuthServiceConfig.js.map